@if (downloadInfo$ | async; as downloadInfo) {
  <div class="download">
    <app-locked-action [locked]="(isLimited$ | async) ?? false">
      <button
        type="button"
        class="btn btn--icon download__btn"
        [ngClass]="{ 'in-progress': downloadInfo.isInProgress }"
        [disabled]="disabled || limitAccess || downloadInfo.isInProgress"
        (click)="download()">
        @if (!downloadInfo.isInProgress) {
          <svg class="icon" width="16" height="16">
            <use xlink:href="#download2"></use>
          </svg>
        } @else {
          <app-loading-animation></app-loading-animation>
        }
      </button>
    </app-locked-action>
  </div>
}
